import * as site from "./site";
export * from "./site";
import * as intlPhone from "intl-tel-input";

window.initIntlPhone = initIntlPhone;
declare global {
    interface Window {
        initIntlPhone?: any;
    }
}

function utilInit() {
    $(document).ready(() => {
        site.setupKendoObjects();
    });


    $(document).on("submit", "form", function (evt) {
        var form = this;

        $(form).find(":input").removeAttr("disabled");
        $(form).find("[data-role='datepicker']").each(function () {
            if ($(this).data("kendoDatePicker"))
                $(this).data("kendoDatePicker").enable(true);
        });

        $(form).find("[data-role='numerictextbox']").each(function () {
            if ($(this).data("kendoNumericTextBox"))
                $(this).data("kendoNumericTextBox").enable(true);
        });

        if ($(form).hasClass("noIntercept")) return;

        evt.preventDefault();

        form.submit();
    });

    site.enableSerializeObject();
    site.enableEnterKeypressOnDialog();
    //site.enableTextWidth();
    //window.gridFilterIconFixEvent = () => site.gridFilterIconFixEvent(40);
}

function initIntlPhone(phone?: JQuery<HTMLElement>) {
    if (phone == null) return;

    var iti = intlPhone(phone[0], {
        initialCountry: "us",
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.8/build/js/utils.js"
    });

    const handleChange = () => {
        var text = iti.getNumber();
        phone.val(text);
    };

    phone.on("change", handleChange);
    phone.on("keyup", handleChange);
}

utilInit();

